module.exports = __webpack_public_path__ + "img/group-search.0830fa5f.svg";